// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import ChangePassword from './components/ChangePassword'
import MainPage from './components/MainPage'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

/* eslint-disable */
const routes = [
  { path: '/new-password', name: 'ChangePassword', component: ChangePassword },
  { path: '/', name: 'Main', component: MainPage }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes 
})

new Vue({
    el:'#app',
    router,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js